/*global google*/
var _module = require('../../module');
var $ = require('jquery');
var _ = require('lodash');
var config = require('config');

require('./_styles.scss');
require('angular-ui-router');
require('../../google-search-autocomplete');
require('../../../filters');
require('../../../services/lr-touch');
require('../../../services/branded-nav');
require('../../../services/user');

_module.requires.push(
    'ui.router'
);

_module.controller('HomeBrandedSearchCtrl', [
    '$log',
    '$timeout',
    '$mdMedia',
    '$brandedNav',
    '$user',
    '$state',

    function HomeBrandedSearchCtrl($log, $timeout, $mdMedia, $brandedNav, $user, $state) {
        $log.debug('HomeBrandedSearchCtrl', this);

        var vm = this;
        vm.model = {
            search: '',
            latLng: undefined
        };
        vm.events = {
            onFormSubmit: onFormSubmit,
            onBlur: backtoTop,
            onQualifyClick: scrollToMyTeam,
            onWhatsMyHomeWorthClick: goToWhatsMyHomeWorth
        };


        // Functions
        function onFormSubmit() {
            if(vm.model.search) {
                $timeout(function onFormSubmitTO() {
                    vm.onSearch({ $value: vm.model.search, $latLng: vm.model.latLng });
                }, 200);
            }
        }

        function backtoTop() {
            if($mdMedia('xs')) {
                $('html, body').animate({ scrollTop: 0 }, 250);
            }
        }

        function scrollToMyTeam() {
            $('html, body').animate({
                scrollTop: $('#contact-us').offset().top
            }, 500);
        }

        function goToWhatsMyHomeWorth() {
            var page;

            if($user.affiliate.vendorId) {
                page = _.find($brandedNav.vendorNavs, { id: config.whats_my_home_worth.vendor });
            } else {
                page = _.find($brandedNav.agentNavs, { id: config.whats_my_home_worth.agent });
            }

            if(page) $state.go('branded-nav-pages', { pageId: page.id, slug: page.content.slug });
        }
    }
]);

_module.component('homebrandedSearch', {
    controllerAs: 'vm',
    controller: 'HomeBrandedSearchCtrl',
    template: require('./index.html'),
    bindings: {
        affiliate: '<',
        onSearch: '&'
    }
});
